// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__35EOG","topBottomGutter":"Layout_topBottomGutter__fvBMW"};